export const getFileNameFromContentDisposition = (header: unknown, fallback: string): string => {
	if (typeof header !== "string" || !header) {
		return fallback;
	}

	const encodedMatch = /filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i.exec(header);
	if (encodedMatch?.[1]) {
		try {
			return decodeURIComponent(encodedMatch[1].trim().replace(/^"|"$/g, ""));
		} catch {
			// fall back to plain filename
		}
	}

	const plainMatch = /filename\s*=\s*"?([^";]+)"?/i.exec(header);
	return plainMatch?.[1]?.trim() || fallback;
};

export const downloadBlob = (blob: Blob, fileName: string) => {
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.setAttribute("download", fileName);
	document.body.appendChild(link);
	link.click();
	link.remove();
	window.URL.revokeObjectURL(url);
};
